module.exports = __webpack_public_path__ + "img/lumen.f83df7a1.png";